import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../../styles/legal-pages.css";
import "../../styles/inner-page.css";

const TermsPage = () => {
    return (
        <div className="page-wrapper inner-page-wrapper">
            <Header />
            <main className="legal-page">
                <div className="container-default w-container">
                    <div className="legal-header">
                        <div className="big-font-title display-2---size">Legal</div>
                        <h1 className="display-2">Terms of Service</h1>
                        <p className="legal-updated">Last updated: January 2, 2026</p>
                    </div>

                    <div className="legal-content">
                        <section className="legal-section">
                            <h2>1. Agreement to Terms</h2>
                            <p>
                                By accessing or using Younivision's services, website, or any applications 
                                (collectively, the "Services"), you agree to be bound by these Terms of Service 
                                ("Terms"). If you do not agree to these Terms, you may not access or use the Services.
                            </p>
                            <p>
                                We reserve the right to modify these Terms at any time. We will notify you of any 
                                changes by updating the "Last updated" date above. Your continued use of the Services 
                                after any such changes constitutes your acceptance of the new Terms.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>2. Description of Services</h2>
                            <p>
                                Younivision provides software development, web development, mobile application 
                                development, and related digital services. The specific scope of services will be 
                                outlined in individual project agreements or statements of work.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>3. User Responsibilities</h2>
                            <p>When using our Services, you agree to:</p>
                            <ul>
                                <li>Provide accurate and complete information when requested</li>
                                <li>Maintain the confidentiality of any account credentials</li>
                                <li>Notify us immediately of any unauthorized use of your account</li>
                                <li>Use the Services only for lawful purposes</li>
                                <li>Not interfere with or disrupt the Services or servers</li>
                                <li>Comply with all applicable laws and regulations</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>4. Intellectual Property</h2>
                            <p>
                                Unless otherwise specified in a separate agreement, all intellectual property rights 
                                in materials we create for you will transfer to you upon full payment. However, 
                                Younivision retains the right to use anonymized versions of work in our portfolio 
                                and marketing materials unless explicitly prohibited in writing.
                            </p>
                            <p>
                                The Younivision name, logo, and all related names, logos, product and service names, 
                                designs, and slogans are trademarks of Younivision. You may not use such marks 
                                without our prior written permission.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>5. Payment Terms</h2>
                            <p>
                                Payment terms will be specified in individual project agreements. Unless otherwise 
                                stated:
                            </p>
                            <ul>
                                <li>Invoices are due within 30 days of receipt</li>
                                <li>Late payments may incur interest at 1.5% per month</li>
                                <li>We reserve the right to suspend services for overdue accounts</li>
                                <li>All fees are non-refundable unless otherwise specified</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>6. Limitation of Liability</h2>
                            <p>
                                To the maximum extent permitted by law, Younivision shall not be liable for any 
                                indirect, incidental, special, consequential, or punitive damages, or any loss of 
                                profits or revenues, whether incurred directly or indirectly, or any loss of data, 
                                use, goodwill, or other intangible losses.
                            </p>
                            <p>
                                Our total liability for any claims under these Terms shall not exceed the amount 
                                you paid us in the twelve (12) months preceding the claim.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>7. Indemnification</h2>
                            <p>
                                You agree to indemnify and hold harmless Younivision, its officers, directors, 
                                employees, and agents from any claims, damages, losses, liabilities, and expenses 
                                (including reasonable attorneys' fees) arising out of your use of the Services or 
                                violation of these Terms.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>8. Termination</h2>
                            <p>
                                Either party may terminate a project agreement with 30 days written notice. Upon 
                                termination, you shall pay for all services rendered up to the termination date. 
                                We may terminate or suspend your access to the Services immediately if you breach 
                                these Terms.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>9. Governing Law</h2>
                            <p>
                                These Terms shall be governed by and construed in accordance with the laws of the 
                                State of South Carolina, without regard to its conflict of law provisions. Any 
                                disputes arising under these Terms shall be resolved in the state or federal courts 
                                located in South Carolina.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>10. Contact Information</h2>
                            <p>
                                If you have any questions about these Terms, please contact us at:
                            </p>
                            <p>
                                <strong>Younivision</strong><br />
                                Email: <a href="mailto:hello@younivision.com">hello@younivision.com</a><br />
                                Website: <a href="https://younivision.com">younivision.com</a>
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default TermsPage;

